// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class PrevAgents {
    lastAgentId: string;
    agentIds: string[];
}